import { render, staticRenderFns } from "./localData.vue?vue&type=template&id=43f5a372&scoped=true"
import script from "./localData.vue?vue&type=script&lang=js"
export * from "./localData.vue?vue&type=script&lang=js"
import style0 from "./localData.vue?vue&type=style&index=0&id=43f5a372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f5a372",
  null
  
)

export default component.exports